import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { isBrowser } from '@websolutespa/bom-core';
import { useState, useEffect, useId } from 'react';
import { createPortal } from 'react-dom';
import { useLlmView } from '../../../useLlm/useLlmView.js';

function Portals(_a) {
  var {
      children
    } = _a,
    props = __rest(_a, ["children"]);
  const portal = useLlmView(state => state.portal);
  const selector = props.selector || portal.selector;
  const replace = props.replace || portal.replace;
  const [portals, setPortals] = useState([]);
  function updatePortals() {
    const newPortals = Array.from(document.querySelectorAll(selector));
    newPortals.forEach(element => {
      if (!element.classList.contains('llm')) {
        element.classList.add('llm', 'llm__reset');
        if (replace) {
          element.innerHTML = '';
        }
      }
    });
    if (newPortals.length !== portals.length) {
      setPortals(newPortals);
    }
  }
  useEffect(() => {
    if (isBrowser) {
      updatePortals();
      const observer = new MutationObserver(mutations => {
        updatePortals();
      });
      observer.observe(document, {
        childList: true,
        subtree: true
      });
      return () => {
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
      };
    } else {
      return () => {};
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selector, replace]);
  return portals.map((element, i) => jsx(Portal, {
    target: element,
    children: children
  }, i));
}
function Portal(_ref) {
  let {
    children,
    target
  } = _ref;
  const id = useId();
  // console.log('Portal', target, id);
  return /*#__PURE__*/createPortal(children, target, id);
}

export { Portal, Portals };
//# sourceMappingURL=portals.js.map
